exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[scale=scale-extra-small][data-v-c0cd4140]{width:16px}", ""]);

